// extracted by mini-css-extract-plugin
export default {"markdown":"index-module--markdown--a498c"};